import * as React from 'react';
import Popper from '@mui/material/Popper';
import { useAxesTooltip } from '@mui/x-charts/ChartsTooltip';
import { useDrawingArea, useSvgRef } from '@mui/x-charts/hooks';
import { ChartsReferenceLine } from '@mui/x-charts/ChartsReferenceLine';

import {
    generateVirtualElement,
    useMouseTracker,
} from 'ff/debrief/components/charts/utils';
import CustomTooltipContent from './CustomTooltipContent';

interface Props {
    boundaryEl: React.RefObject<Element>;
}

export function CustomTooltip(props: React.PropsWithChildren<Props>) {
    const axisData = useAxesTooltip();
    const mousePosition = useMouseTracker();
    const svgRef = useSvgRef(); // Get the ref of the <svg/> component.
    const drawingArea = useDrawingArea(); // Get the dimensions of the chart inside the <svg/>.
    const tooltipContentRef = React.useRef<HTMLDivElement>(null);

    if (!axisData || !mousePosition || !svgRef.current) {
        // No data to display
        return null;
    }

    const tooltipPosition = {
        x: mousePosition.viewportPoint.x,
        y: svgRef.current.getBoundingClientRect().top + drawingArea.top,
    };

    return (
        <React.Fragment>
            <Popper
                sx={{
                    pointerEvents: 'none',
                    zIndex: theme => theme.zIndex.modal,
                }}
                modifiers={[
                    {
                        name: 'preventOverflow',
                        options: {
                            boundary: props.boundaryEl.current,
                            tether: false,
                        },
                    },
                ]}
                open
                placement="top"
                anchorEl={generateVirtualElement(tooltipPosition)}
            >
                <CustomTooltipContent
                    ref={tooltipContentRef}
                    axisData={axisData}
                />
            </Popper>
            <ChartsReferenceLine
                x={mousePosition.xAxisValue}
                lineStyle={{ strokeDasharray: '4 6' }}
            />
        </React.Fragment>
    );
}

export default CustomTooltip;
